module.exports = __webpack_public_path__ + "static/media/key.f6aa58eb.svg";